<template>
  <div :class="['spinner-container w-100', { 'absolute': isAbsolute, 'flex-centered py-5': !isAbsolute, 'spinner-full-screen': isFullScreen }]" v-if="visible">
    <div class="spinner-bg">
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  visible: { type: Boolean, default: false },
  isAbsolute: { type: Boolean, default: false },
  isFullScreen: { type: Boolean, default: false },
});
</script>

<style lang="scss" scoped>
.absolute {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 150;
  background-color: rgba(255, 255, 255, 0.55);
  height: 100%;
  min-height: 80px;

  &.spinner-full-screen {
    position: fixed;
  }

  .spinner-bg {
    z-index: 150;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.spinner {
  width: 48px;
  height: 48px;
  border: 5px solid $primary;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1.3s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>